import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  placeholder: {
    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
    overflow: 'hidden',
    display: 'inline-block',
  },
  '@keyframes gradientAnim': {
    '0%': {
      backgroundPosition: [[-468, 0]],
    },
    '100%': {
      backgroundPosition: [[468, 0]],
    },
  },
  animatedBackground: {
    display: 'inline-block',
    borderRadius: theme.borderRadius.std,

    animationDuration: 1250,
    animationFillMode: 'forwards',
    animationIterationCount: 'infinite',
    animationName: '$gradientAnim',
    animationTimingFunction: 'linear',
    background: `linear-gradient(to right, ${
      theme.colors.grayBackground
    } 10%, ${theme.basicColors.grayBackground.darken(0.05)} 25%, ${
      theme.colors.grayBackground
    } 40%)`,
    fallbacks: {
      background: theme.colors.grayBackground,
    },
    backgroundSize: '800px 104px',
    position: 'relative',
  },
  animatedBackgroundWhite: {
    animationDuration: 4000,
    background: `linear-gradient(to right, ${
      theme.colors.white
    } 10%, ${theme.basicColors.grayBackground.darken(0.02)} 40%, ${
      theme.colors.white
    } 80%)`,
    fallbacks: {
      background: theme.colors.grayBackground,
    },
  },
  placeholderText: {
    opacity: 0,
  },
}));

interface Props {
  sample?: React.ReactNode;
  className?: string;
  overGray?: boolean;
}

export const TextLoadingPlaceholder = ({
  sample,
  className,
  overGray,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classnames(className, classes.placeholder)}
      role="presentation"
    >
      <div
        className={classnames(classes.animatedBackground, {
          [classes.animatedBackgroundWhite]: overGray,
        })}
      >
        <span className={classes.placeholderText}>
          {sample || 'Text is loading'}
        </span>
      </div>
    </div>
  );
};
